import React, { useEffect, useState } from "react";
import LightbarDrawing from "./LightbarDrawing";
import { LIGHTBAR_LIGHTHEAD_MODAL_TITLE } from "../../../services/Constant";

const PreviewLightheadComponent = ({
  lightData,
  currentZoneData,
  closePreviewLightheadModel,
  prevSelectedIds,
  excludedLightbarDuoTrio,
  onAllPreviewLightheadsUnchecked,
  previewZoneDataArrayIndex,
  previewZoneArea,
  closeModel,
}) => {
  let isSoloAvailable = false;
  const tooltipLines = currentZoneData?.tooltipData ? currentZoneData.tooltipData.split(/<br\s*\/?>/i).length : 1;

  const tableHeight = 420 + (tooltipLines - 1) * 35;
  const [arrayToExclude, setArrayToExclude] = useState([]);
  const [selectedLightheads, setSelectedLightheads] = useState([]);

  const updateArrayToExclude = (key, value, checked) => {
    setArrayToExclude((prev) => {
      const exists = prev?.some((item) => item[key] === value);

      // Checkbox is unchecked → add
      if (!checked && !exists) {
        return [
          ...prev,
          {
            [key]: value,
          },
        ];
      }

      // Checkbox is checked → remove
      if (checked && exists) {
        return prev.filter((item) => item[key] !== value);
      }

      return prev;
    });
  };

  const colorMap = [...(currentZoneData?.lightheads || [])]
    .sort((a, b) => {
      if (a.lightheadPosition == null) return 0;
      if (b.lightheadPosition == null) return 0;

      return a.lightheadPosition - b.lightheadPosition;
    })
    .reduce(
      (acc, lighthead, i) => ({
        ...acc,
        [i]: Object.keys(lighthead.color).map((key) => ({
          ...lighthead,
          ...lighthead.color[key],
        })),
      }),
      {}
    );

  const handleClosePreview = () => {
    let lightHeads = [];
    let selLightheadArray = [];

    const hasLightheads = currentZoneData?.lightheads?.length > 0;
    if (hasLightheads && lightData && lightData.length > 0) {
      isSoloAvailable = lightData.some(
        (light) => light.moduleOutputs && Array.isArray(light.moduleOutputs) && light.moduleOutputs.length === 1
      );
    }
    const allLightheadsUnchecked = hasLightheads && selectedLightheads.length === 0 && !isSoloAvailable;
    lightHeads =
      arrayToExclude.length > 0
        ? [
            {
              lightbarId: currentZoneData.lightId,
              lightheadIds: arrayToExclude,
            },
          ]
        : [];

    selLightheadArray =
      arrayToExclude.length > 0
        ? [
            {
              lightbarId: currentZoneData.lightId,
              lightheadIds: selectedLightheads,
              excludedIds: arrayToExclude,
            },
          ]
        : [];

    if (allLightheadsUnchecked) {
      onAllPreviewLightheadsUnchecked?.(previewZoneDataArrayIndex, previewZoneArea, currentZoneData);
      closePreviewLightheadModel([], [], isSoloAvailable);
    } else {
      closePreviewLightheadModel(lightHeads, selLightheadArray, isSoloAvailable);
    }
  };

  useEffect(() => {
    const allIds = [];
    Object.keys(colorMap).forEach((colorRow) => {
      colorMap[colorRow].forEach((row) => {
        allIds?.push(`${row?.id}-${row?.color}`);
      });
    });
    const found = (prevSelectedIds || []).find((item) => item.lightbarId === currentZoneData.lightId);

    isSoloAvailable = lightData.some(
      (light) => light.moduleOutputs && Array.isArray(light.moduleOutputs) && light.moduleOutputs.length === 1
    );

    if (found) {
      setSelectedLightheads(found.lightheadIds);
      setArrayToExclude(found.excludedIds);
    } else if (isSoloAvailable && excludedLightbarDuoTrio.length > 0) {
      // checking if previously we have all unchecked ids hence every checkbox are unchecked
      const available = excludedLightbarDuoTrio.find((item) => item.lightbarId === currentZoneData.lightId);
      if (available && Object.keys(available).length > 0) {
        setSelectedLightheads([]);
        setArrayToExclude(available?.lightheadIds);
      } else {
        setSelectedLightheads(allIds);
      }
    } else {
      setSelectedLightheads(allIds);
    }
  }, [currentZoneData]);

  const solo = (currentZoneData?.lightheads || [])?.length === 0;

  return (
    <>
      <div id="previewLightbar-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="d-flex align-items-center">
              <h2 className="modal-title text-white text-uppercase mt-0">{LIGHTBAR_LIGHTHEAD_MODAL_TITLE}</h2>
              <div className="close-icon text-end ms-auto">
                <button type="button" className="close" data-dismiss="modal" onClick={() => closeModel()}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <LightbarDrawing
                lightData={lightData}
                currentZoneData={currentZoneData}
                tooltipData={currentZoneData?.tooltipData}
              />
              {!solo ? (
                <>
                  <div className="table-responsive" style={{ height: `calc(100vh - ${tableHeight}px)` }}>
                    <table className="table el-header table-bordered align-middle table-dark table-sm-cell">
                      <thead>
                        <tr>
                          {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? (
                            <th>Lighthead Position</th>
                          ) : null}
                          <th>Source</th>
                          <th>Position</th>
                          <th>Include</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(colorMap)
                          .filter((colorRow) => colorMap[colorRow].length > 1)
                          .map((colorRow, mainIndex) =>
                            colorMap[colorRow].map((row, colorIndex) => {
                              const rowNumber =
                                Object.keys(colorMap)
                                  .slice(0, mainIndex)
                                  .reduce((total, key) => total + colorMap[key].length, 0) +
                                colorIndex +
                                1;
                              return (
                                <tr key={`${colorRow}-${row.id + colorIndex}`}>
                                  {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? (
                                    <td>{colorIndex <= 0 && row?.lightheadPosition ? row?.lightheadPosition : null}</td>
                                  ) : null}
                                  <td>{`${row?.modelNumber} - ${row?.color}`}</td>
                                  <td>{row.position}</td>
                                  <td>
                                    <input
                                      type="checkbox"
                                      className="form-check-input-1"
                                      id={rowNumber}
                                      checked={selectedLightheads?.includes(`${row.id}-${row.color}`)}
                                      onChange={(e) => {
                                        const key = `${row.id}-${row.color}`;

                                        setSelectedLightheads((prev) => {
                                          const updated = e.target.checked
                                            ? [...prev, key]
                                            : prev.filter((item) => item !== key);
                                          return updated;
                                        });

                                        updateArrayToExclude(row?.id, row?.color, e.target.checked);
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          )}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : null}
            </div>
            {!solo ? (
              <>
                <div className="action-btn d-flex justify-content-end">
                  <button type="button" onClick={closeModel} className="btn me-3 btn-red text-white text-uppercase">
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => handleClosePreview()}
                    className="btn btn-red text-white text-uppercase apply"
                  >
                    Apply
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewLightheadComponent;
